import React from "react";
import { Box, Container, Grid } from "@mui/material";
import { Breadcrumbs } from "../Breadcrumbs";
import PageTitle from "../PageTitle";
import { Segment } from "../Segment";
import ImgBgMeshLeftHalf from "../../assets/images/how-qv-works-bg-right.webp";

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

export interface PageLayoutProps {
  children: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  py?: { xs: number; md: number };
  spacing?: number;
  sidebarContent?: React.ReactNode;
  sidebarWidth?: { xs: number; lg: number };
  contentWidth?: { xs: number; lg: number };
  // New props for breadcrumbs and page title
  breadcrumbs?: BreadcrumbItem[];
  pageTitle?: string;
  pageSubtitle?: string;
  pageTitleCta?: React.ReactNode;
  showBreadcrumbs?: boolean;
  showPageTitle?: boolean;
  showBgMesh?: boolean;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  maxWidth = "lg",
  py = { xs: 2, md: 8 },
  spacing = 6,
  sidebarContent,
  sidebarWidth = { xs: 12, lg: 4 },
  contentWidth = { xs: 12, lg: 8 },
  // New props
  breadcrumbs,
  pageTitle,
  pageSubtitle,
  pageTitleCta,
  showBreadcrumbs = false,
  showPageTitle = false,
  showBgMesh = false,
}) => {
  // If there's no sidebar, make content take full width and remove spacing
  const effectiveContentWidth = sidebarContent
    ? contentWidth
    : { xs: 12, lg: 12 };
  const effectiveSpacing = sidebarContent ? spacing : 0;
  return (
    <>
      <Segment variant={showBgMesh ? "bg" : "collapse"} collapse>
        <Box position="relative">
          <Box>
            {/* Breadcrumbs Section */}
            {showBreadcrumbs && breadcrumbs && (
              <Container
                maxWidth={maxWidth}
                sx={{
                  py: { xs: 0, md: 3 },
                  px: { xs: 0, md: 3 },
                }}
              >
                <Breadcrumbs items={breadcrumbs} />
              </Container>
            )}

            {/* Page Title Section */}
            {showPageTitle && pageTitle && (
              <Container
                maxWidth={maxWidth}
                sx={{
                  py: { xs: 0, md: 6 },
                  px: { xs: 0, md: 3 },
                }}
              >
                <Box position="relative" zIndex={101}>
                  <PageTitle
                    title={pageTitle}
                    subtitle={pageSubtitle}
                    cta={pageTitleCta}
                  />
                </Box>
              </Container>
            )}
          </Box>
          {/* <Box position="absolute" bottom={0} right={0} zIndex={100}>
            <Box component="img" src={ImgBgMeshLeftHalf} width="100%" />
          </Box> */}
        </Box>
      </Segment>

      {/* Main Content Section */}
      <Container
        maxWidth={maxWidth}
        sx={{
          py,
          px: { xs: 0, md: 3 },
        }}
      >
        <Grid container spacing={{ xs: 0, md: effectiveSpacing }}>
          {/* Main Content Area */}
          <Grid size={effectiveContentWidth}>{children}</Grid>

          {/* Sidebar Area */}
          {sidebarContent && (
            <Grid size={sidebarWidth}>
              <Box sx={{ position: "sticky", top: 24 }}>{sidebarContent}</Box>
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
};
